import { HTMLAttributes, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ElementNames, ElementNameType } from 'constants/app';
import useElementSize from 'hooks/useElementSize';
import { setElementHeight } from 'redux/modules/appSettings';

interface ElementHeightObserverProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  elementName?: ElementNameType;
}

const ElementHeightObserver = ({
  children,
  elementName = ElementNames.CONTENT_HEIGHT,
  ...props
}: ElementHeightObserverProps) => {
  const dispatch = useDispatch();
  const [wrapperRef] = useElementSize<HTMLDivElement>({
    onChangeSizesHandler: ({ height }) => {
      dispatch(setElementHeight({ name: elementName, height }));
    }
  });

  useEffect(() => {
    return () => {
      dispatch(setElementHeight({ name: elementName, height: 0 }));
    };
  }, [dispatch, elementName]);

  return (
    <div ref={wrapperRef} {...props}>
      {children}
    </div>
  );
};

export default ElementHeightObserver;
